import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 46"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M24.75 23H8.25v5.75h16.5zm7.648-13.566L23.985.629A2.02 2.02 0 0 0 22.525 0H22v11.5h11v-.548a2.2 2.2 0 0 0-.602-1.518M19.25 12.219V0H2.063C.92 0 0 .961 0 2.156v41.688C0 45.039.92 46 2.063 46h28.875C32.08 46 33 45.039 33 43.844V14.375H21.313c-1.135 0-2.063-.97-2.063-2.156M5.5 6.469c0-.397.308-.719.688-.719h6.875c.38 0 .687.322.687.719v1.437c0 .397-.308.719-.687.719H6.187c-.38 0-.687-.322-.687-.719zm0 5.75c0-.397.308-.719.688-.719h6.875c.38 0 .687.322.687.719v1.437c0 .397-.308.719-.687.719H6.187c-.38 0-.687-.322-.687-.719zm22 27.312c0 .397-.308.719-.687.719h-6.875c-.38 0-.688-.322-.688-.719v-1.437c0-.397.308-.719.688-.719h6.875c.38 0 .687.322.687.719zm0-17.968v8.625c0 .794-.615 1.437-1.375 1.437H6.875c-.76 0-1.375-.643-1.375-1.437v-8.625c0-.795.615-1.438 1.375-1.438h19.25c.76 0 1.375.643 1.375 1.438"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }